import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const memoryBankStoreStep = defineStepConfig({
  type: "memory_bank_store",
  name: "Store Memory",
  description:
    "Save a note to the memory bank scoped to this workflow. Stored memories survive workflow version edits and can be read back with the Retrieve Memories node.",
  category: "AI & Agents",

  experimental: {
    reason:
      "Workflow-scoped memories are under active development; storage and retrieval semantics may still change.",
  },

  inputSchema: z.object({
    note: z
      .string()
      .min(1)
      .max(10000)
      .describe("The memory content to store (markdown supported)."),
  }),

  outputSchema: z.object({
    noteId: z
      .string()
      .describe("Id of the created memory bank note (empty on eval runs)."),
    stored: z.boolean().describe("Whether the note was persisted."),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "1 minute",
    retry: {
      maximumAttempts: 2,
    },
  },
});
